import { render, staticRenderFns } from "./CreateItemModal.vue?vue&type=template&id=3fa33bd4&lang=pug&"
import script from "./CreateItemModal.vue?vue&type=script&lang=ts&"
export * from "./CreateItemModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateItemModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports